import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

export const MonthFullName = styled(Typography)(({ theme }) => ({
  textTransform: 'capitalize',
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4)
}));

export const Day = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  cursor: 'pointer',
  borderWidth: 2,
  borderStyle: 'solid',
  borderColor: 'transparent'
}));

export const DayShortName = styled('p')(({ theme }) => ({
  marginTop: '5px',
  color: theme.palette.brand.mediumGreen,
  fontWeight: 600,
  textTransform: 'capitalize'
}));

export const DayNumber = styled(Typography)(() => ({
  marginBottom: '5px'
}));

export const ArrowButtonPrev = styled(IconButton)(({ theme }) => ({
  width: 32,
  height: 32,
  backgroundColor: theme.palette.neutrals.beige3,
  left: 0,
  position: 'absolute',
  top: '60%',
  transform: 'translate(0, -60%)',
  zIndex: 1
}));

export const ArrowButtonNext = styled(IconButton)(({ theme }) => ({
  width: 32,
  height: 32,
  backgroundColor: theme.palette.neutrals.beige3,
  position: 'absolute',
  right: 0,
  top: '60%',
  transform: 'translate(0, -60%)',
  zIndex: 1
}));

export const SliderProvider = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: '0 45px',

  marginBottom: theme.spacing(3),
  '& .selected': {
    borderColor: theme.palette.colored.lilac,
    borderRadius: '4px'
  }
}));
